import makeStyles from '@mui/styles/makeStyles'
import '@fontsource/roboto/400.css'
const useLoginStyles = makeStyles({
  root: {
    '& input:-webkit-autofill': {
      '&::before': {
        backgroundColor: 'transparent',
      },
      '&::after': {
        backgroundColor: 'transparent',
      },
    },
    '& input:-internal-autofill-selected': {
      backgroundColor: 'transparent',
    },
  },
  welcometext: {
    fontSize: '18px',
    color: '#015293',
    fontWeight: 400,
    textAlign: 'start',
    lineHeight: '21px',
    fontFamily: 'roboto',
    // marginBottom: '20px',
  },
  welcomediv: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  headtext: {
    fontSize: '72px',
    color: '#015293',
    fontWeight: 400,
    textAlign: 'start',
    lineHeight: '84px',
    fontFamily: 'roboto',
  },
  headsectext: {
    fontSize: '36px',
    color: '#015293',
    fontWeight: 400,
    textAlign: 'start',
    lineHeight: '42px',
    fontFamily: 'roboto',
  },
  bottomdiv: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 10,
  },
  smallheadtext: {
    padding: '0px 10px',
    fontSize: '12px',
    color: '#015293',
    fontWeight: 400,
    width: '100%',
    fontFamily: 'roboto',
  },
  distributedbottom: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  renewdiv: {
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  Solarplantimg: {
    height: '24.5rem',
    width: '31.25rem',
  },
  logintext: {
    fontSize: '36px',
    color: '#FFFFFF',
    fontWeight: 400,
    width: '100%',
    fontFamily: 'roboto',
    marginTop: '2.75rem',
    lineHeight: '2.625rem',
    textAlign: 'center',
    '@media (max-width: 600px)': {
      fontSize: '28px',
      marginTop: '1.5rem',
    },
  },
  lighbluetext: {
    fontSize: '12px',
    color: '#A5B3FE',
    fontWeight: 400,
    fontFamily: 'roboto',
    lineHeight: '0.875rem',
  },
  loginContainer: {
    backgroundColor: '#5968B7',
    height: 'auto',
    minHeight: '29.875rem',
    width: '100%',
    maxWidth: '29.563rem',
    borderRadius: '1.25rem',
    margin: '10px',
    padding: '0 2rem',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.2)',
    '@media (max-width: 600px)': {
      width: '95%',
      margin: '0 auto',
      minHeight: 'unset',
      borderRadius: '20px',
      padding: '0 1.5rem',
    },
  },
  verticalalign: {
    display: 'flex',
    flexDirection: 'column !important',
    justifyContent: 'space-between !important',
    height: '100%',
    width: '100%',
  },
  textCenter: {
    textAlign: 'center',
  },
  errorText: {
    fontSize: '16px',
    color: 'orange',
    fontWeight: 400,
    width: '100%',
    fontFamily: 'roboto',
    textAlign: 'center',
  },
  resettext: {
    fontSize: '18px',
    color: '#FFFFFF',
    fontWeight: 400,
    width: '100%',
    fontFamily: 'roboto',
    marginTop: '2.75rem',
    lineHeight: '2.625rem',
    textAlign: 'center',
    '@media (max-width: 600px)': {
      fontSize: '20px',
      marginTop: '1.5rem',
    },
  },
  resettextdetails: {
    fontSize: '12px',
    color: '#FFFFFF',
    fontWeight: 300,
    width: '100%',
    fontFamily: 'roboto',
    // marginTop: '2.75rem',
    // lineHeight: '2.625rem',
    textAlign: 'center',
    paddingLeft: '3.188rem',
    paddingRight: '3.188rem',
  },
  loginFormWrapper: {
    padding: '3.188rem',
    '@media (max-width: 600px)': {
      padding: '2rem 1.5rem',
    },
  },
})

export default useLoginStyles
